import "./InsuranceConfigurationScreenComponent.scss";
import * as Yup from "yup";
import {Formik, Form, FieldProps, Field, FormikHelpers} from "formik";
import CommonService from "../../../shared/services/common.service";
import React, {useCallback, useEffect, useState} from "react";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import AddIcon from "@mui/icons-material/Add";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import FeedbackComponent from "../../../shared/components/feedback/feedbackComponent";
import FormikInputComponent from "../../../shared/components/core/formik-input/FormikInputComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {AttachFile} from "@mui/icons-material";
import FileDragAndDropComponent from "../../../shared/components/file-drag-n-drop/FileDragAndDropComponent";
import {ITableColumn} from "../../../shared/models/table.model";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import {IClearingHouse} from "../../../shared/models/insurance.model";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import ClearingHouseInsurancePreviewComponent
    from "./clearing-house-insurance-preview/ClearingHouseInsurancePreviewComponent";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {APIConfig, ImageConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import DownloadIcon from "@mui/icons-material/Download";
import commonService from "../../../shared/services/common.service";
import {getInsuranceCompanyData} from "../../../store/actions/staticData.action";
import {useDispatch} from "react-redux";

interface InsuranceConfigurationScreenComponentProps {

}

const initialDrawerConfig = {
    isOpen: false as boolean,
}
const initialInsuranceModalConfig = {
    isOpen: false as boolean,
    clearingHouse: null as string | null,
    clearingHouseId: null as string | number | null,
    modalType: 'view' as 'add' | 'view',
    sessionFile: null as File | null,
}

const clearingHouseValidationSchema = Yup.object().shape({
    clearingHouse: Yup.string().nullable().required(),
    file: Yup.mixed().nullable().required(),
})

interface clearingHouseValidationFormSchema {
    clearingHouse: string | null,
    file: File | null,
}

const clearingHouseValidationForm: clearingHouseValidationFormSchema = {
    clearingHouse: '',
    file: null,
}
const MODULE_NAME = 'clearing house table'
const InsuranceConfigurationScreenComponent = (props: InsuranceConfigurationScreenComponentProps) => {
    const [drawerConfig, setDrawerConfig] = useState<typeof initialDrawerConfig>(initialDrawerConfig)
    const [modalconfig, setModalConfig] = useState<typeof initialInsuranceModalConfig>(initialInsuranceModalConfig);
    const [isInsuranceDownloading, setIsInsuranceDownloading] = useState<{ [key: string]: boolean }>({});
    const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);
    const dispatch = useDispatch();

    const updateClearingHouse = useCallback((clearingHouseId: string | number): void => {
        if (clearingHouseId) {
            CommonService._patient.toggleClearingHouse(clearingHouseId).then((response) => {
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                dispatch(getInsuranceCompanyData())
                CommonService._alert.showToast(response?.message || 'Successfully changed clearing house', 'success');
            }).catch((error) => {
                CommonService._alert.showToast(error?.error || 'Failed to toggle clearing house', 'error');
            })
        } else {
            CommonService._alert.showToast('Clearing house Id not found', 'error');
        }
    }, [dispatch])
    const handleOpenDrawer = useCallback(() => {
        setDrawerConfig((prev) => ({...prev, isOpen: true}))
    }, [])

    const [initialClearingHouseState, setClearingHouseState] = useState(clearingHouseValidationForm)
    const handleResultFilesDrop = useCallback((files: any, setFieldValue: (field: string, value: any, shouldValidate?: (boolean | undefined)) => void) => {
        const file = files[0];
        setFieldValue("file", file, true)
    }, []);

    const handleSubmitClearingHouse = useCallback((values: clearingHouseValidationFormSchema, formikHelpers: FormikHelpers<typeof initialClearingHouseState>): void => {
        const payload = {
            ...values,
            clearingHouseCode: values.clearingHouse?.split(" ").join("_").toLowerCase(),
        } as clearingHouseValidationFormSchema & { clearingHouseCode: string };
        const formData = new FormData();
        for (const field in payload) {
            if (payload.hasOwnProperty(field)) {
                formData.append(field, payload[field as keyof typeof payload] as string | File);
            }
        }
        CommonService._patient.addClearingHouseInsurances(formData).then((response) => {
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            });
            CommonService._alert.showToast(response?.message || 'Successfully added clearing house', 'success');
            formikHelpers.resetForm();
            setClearingHouseState(clearingHouseValidationForm);
            setDrawerConfig(initialDrawerConfig);//resetting the state to default after submit
        }).catch((error) => {
            CommonService._alert.showToast(error?.error || 'Failed to add clearing house', 'error');
        }).then(() => {
            formikHelpers.setSubmitting(false);
        })
        console.log({payload, formData}, 'the clearing house payload')
    }, [])

    const handleClearingHouseToggle = useCallback((clearingHouse: IClearingHouse) => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: `Are you sure you want to change clearing house to ${clearingHouse?.clearingHouse}`,
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: `Update`,
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "secondary"
            }
        })
            .then(() => {
                updateClearingHouse(clearingHouse?.id)
            })
            .catch(() => {
            })
    }, [updateClearingHouse]);

    const downloadTemplate = useCallback(() => {
        setIsTemplateDownloading(true);
        CommonService._patient.downloadInsuranceTemplate()
            .then((res: any) => {
                commonService.downloadFile(res?.data?.url, 'bulk-insurance-template.xlsx', 'xlsx')
            })
            .catch((error) => {
                commonService._alert.showToast(error.error || 'Something went wrong while downloading template');
            }).finally(() => {
            setIsTemplateDownloading(false);
        })
    }, []);

    const downloadClearingHouseFile = useCallback((clearingHouseId: string | number) => {
        setIsInsuranceDownloading((prev) => {
            return {...prev, [clearingHouseId]: true}
        });
        CommonService._patient.downloadClearingHouseInsurances(clearingHouseId).then((response) => {
            if (response.data?.attachmentUrl) {
                CommonService.downloadFile(response.data?.attachmentUrl, response.data?.title || 'clearingHouse', 'csv');
            } else {
                CommonService._alert.showToast('No file found', 'error');
            }
        }).catch((error) => {
            CommonService._alert.showToast(error?.error || 'Failed to download clearing house file', 'error');
        }).finally(() => {
            setIsInsuranceDownloading((prev) => {
                return {...prev, [clearingHouseId]: false}
            });
        })
    }, [])

    const clearingHouseColumns: ITableColumn[] = [
        {
            id: 'clearingHouse',
            label: 'Clearing House',
            isDefaultColumn: true,
            width: "250",
            fixed: "left",
        },
        {
            id: 'isActive',
            label: 'Active/Inactive',
            width: '100',
            align: "center",
            isDefaultColumn: true,
            content: (item: IClearingHouse) => {
                const component = <SwitchComponent
                    size={"small"}
                    checked={!!item?.isActive}
                    disabled={!!item?.isActive}
                    onUpdate={() => handleClearingHouseToggle(item)}
                />
                return (
                    <React.Fragment>
                        {item?.isActive ? <TooltipComponent
                                placement={"top"}
                                arrow
                                enterDelay={2000}
                                tooltip={"Please active any other clearing house order to deactivate current clearing house"}>
                                <div>
                                    {component}
                                </div>
                            </TooltipComponent> :
                            component
                        }
                    </React.Fragment>
                )
            }
        },
        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            align: "center",
            width: "200",
            hideInColumnPreferences: true,
            fixed: "right",
            content: (item: IClearingHouse, index: any) => (
                <React.Fragment>
                    <div className="table-actions d-flex gap-10 justify-content-flex-end">
                        <ButtonComponent
                            variant={'text'}
                            color={'primary'}
                            handleClick={() => {
                                setModalConfig((prev) => {
                                    return {
                                        ...prev,
                                        isOpen: true,
                                        clearingHouse: item.clearingHouse,
                                        clearingHouseId: item.id,
                                        modalType: 'view'
                                    }
                                })
                            }}
                        >
                            View
                        </ButtonComponent>
                        <ButtonComponent
                            variant={'text'}
                            color={'secondary'}
                            isLoading={isInsuranceDownloading[item.id]}
                            handleClick={() => {
                                downloadClearingHouseFile(item.id)
                            }}
                        >
                            Download
                        </ButtonComponent>
                    </div>
                </React.Fragment>
            )
        },
    ]

    return (
        <div className={'insurance-configuration-screen-component'}>
            <section>
                <div className={'d-flex-wrap align-items-center justify-content-flex-end'}>
                    <div className={'feature-action-button d-flex-wrap align-items-center gap-10'}>
                        <ButtonComponent
                            type="button"
                            id="template_btn"
                            color={"secondary"}
                            variant={"contained"}
                            isLoading={isTemplateDownloading}
                            fullWidth={false}
                            handleClick={() => {
                                downloadTemplate();
                            }}
                            startIcon={<DownloadIcon/>}
                        >
                            Download Template
                        </ButtonComponent>
                        <ButtonComponent
                            variant={"contained"}
                            color={"primary"}
                            startIcon={<AddIcon/>}
                            handleClick={handleOpenDrawer}
                        >
                            Add Clearing House
                        </ButtonComponent>
                    </div>
                </div>
                <div className="horizontal-line"/>
                <div className="form-sub-title">Clearing House</div>
                <FeedbackComponent className={'mrg-bottom-20'}>
                    <div className={'d-flex pdd-left-10'}>
                        <p>
                            Clearing house can be selected once at a time, existing clearing house will be deactivate
                            after activation of other clearing house
                        </p>
                    </div>
                </FeedbackComponent>
                <div className={'clearing-house-list-container'}>
                    <TableWrapperV2Component
                        isPaginated={false}
                        columns={clearingHouseColumns}
                        url={APIConfig.GET_PATIENT_CLEARING_HOUSE_LIST.URL}
                        method={APIConfig.GET_PATIENT_CLEARING_HOUSE_LIST.METHOD}
                        // extraPayload={{}}
                        isColumnFilterVisible={false}
                        isStickyHeader={true}
                        moduleName={MODULE_NAME}
                    />
                </div>
            </section>
            <DrawerComponent
                open={drawerConfig.isOpen}
                className={"drawer-wrapper"}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                title={"Add Insurance Clearing House"}
                onClose={() => setDrawerConfig(initialDrawerConfig)}
            >
                <div className="screen t-form-screen">
                    <div className="t-form t-form-drawer">
                        <Formik
                            validationSchema={clearingHouseValidationSchema}
                            initialValues={initialClearingHouseState}
                            onSubmit={handleSubmitClearingHouse}
                        >
                            {({
                                  isSubmitting,
                                  values,
                                  touched,
                                  setFieldError,
                                  errors,
                                  isValid,
                                  setFieldValue,
                                  validateForm
                              }) => {
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                useEffect(() => {
                                    //saving the form data to state, so after closing the drawer also get the previous form data
                                    const autosaveTimeout = setTimeout(() => {
                                        setClearingHouseState(values); // Auto-save after a short delay
                                    }, 1000); // Delay before autosave (e.g., 1 second)

                                    return () => clearTimeout(autosaveTimeout); // Clean up timeout
                                }, [values]);
                                return <Form>
                                    <div className="t-form-controls-wrapper mrg-top-20">
                                        <FeedbackComponent className={'mrg-bottom-20'}>
                                            <div>
                                                <div>Important Requirements</div>
                                                <div className={'d-flex pdd-left-10'}>
                                                    <li></li>
                                                    Make sure the template you are uploading was downloaded from
                                                    ‘Download
                                                    Templates’ section and has exactly the same headers.
                                                </div>
                                            </div>
                                        </FeedbackComponent>
                                        <Field name={'clearingHouse'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Clearing House Name'}
                                                        placeholder={'Enter Clearing House Name'}
                                                        required={true}
                                                        multiline={false}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <Field name={'files'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <>
                                                        <FileDragAndDropComponent
                                                            multiple={false}
                                                            // title={"Attachments image/pdf"}
                                                            onFilesDrop={(value: any) => {
                                                                handleResultFilesDrop(value, setFieldValue)
                                                            }}
                                                            acceptedFileTypes={{
                                                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': []
                                                            }}
                                                            fileSizeLimitText={"Select clearing house xlsx file file"}
                                                        />
                                                        {
                                                            values?.file && (
                                                                <ChipComponent
                                                                    label={values?.file?.name}
                                                                    onDelete={() => {
                                                                        setFieldValue('file', null);
                                                                    }}
                                                                    icon={<AttachFile/>}
                                                                    className={'attachment-chip-item mrg-bottom-15 mrg-right-15'}
                                                                />
                                                            )
                                                        }
                                                    </>
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="drawer-actions form-action-section">
                                        <ButtonComponent variant={"contained"}
                                                         fullWidth={true}
                                                         disabled={!values.file || isSubmitting}
                                                         handleClick={() => {
                                                             setModalConfig((prev) => {
                                                                 return {
                                                                     isOpen: true,
                                                                     clearingHouse: values.clearingHouse,
                                                                     clearingHouseId: null,
                                                                     modalType: 'add',
                                                                     sessionFile: values.file
                                                                 }
                                                             });
                                                             setDrawerConfig((prev) => {
                                                                 return {...prev, isOpen: false}
                                                             });
                                                         }}
                                                         startIcon={<RemoveRedEyeIcon/>}
                                                         color={"secondary"}>
                                            Preview
                                        </ButtonComponent>
                                        <ButtonComponent variant={"contained"}
                                                         fullWidth={true}
                                                         type={'submit'}
                                                         isLoading={isSubmitting}
                                                         disabled={!isValid}
                                                         color={"primary"}>
                                            Submit
                                        </ButtonComponent>
                                    </div>
                                </Form>
                            }}
                        </Formik>
                    </div>
                </div>
            </DrawerComponent>
            <DialogComponent open={modalconfig.isOpen}
                             onClose={() => {
                                 setModalConfig(initialInsuranceModalConfig)
                             }}
                             title={`${modalconfig.clearingHouse} Insurance List`}
                             isShowCancel={modalconfig.modalType === 'view'}
                             maxWidth={"xl"}>
                {
                    modalconfig.isOpen &&
                    <ClearingHouseInsurancePreviewComponent
                        onClose={() => {
                            setModalConfig(initialInsuranceModalConfig)
                        }}
                        modalConfig={modalconfig}
                        onSubmit={() => {
                            setDrawerConfig((prev) => {
                                return {...prev, isOpen: true}
                            });
                            setModalConfig(initialInsuranceModalConfig)
                        }}
                    />
                }
            </DialogComponent>
        </div>
    );

};

export default InsuranceConfigurationScreenComponent;
